import fontColorContrast from "font-color-contrast";
import { useMemo } from "react";

export const useContrastText = (bgColor: string) => {
    const whiteColor = "#ffffff";
    const blackColor = "#000000";

    // If the background color is empty, we'll use white as the default color
    const backgroundColor = bgColor || whiteColor;

    const color = useMemo(() => {
        return fontColorContrast(backgroundColor);
    }, [backgroundColor]);

    const isWhite = color === whiteColor;
    const isBlack = color === blackColor;

    return { color, isWhite, isBlack };
};
